<ng-container *ngIf="collapsible; else nonCollapsibleTemplate">
    <p-accordion [(activeIndex)]="accordionActiveIndex">
        <p-accordionTab>
            <ng-template pTemplate="header">
                <div class="flex align-items-center justify-content-between w-full pr-2">
                    <div class="flex align-items-center gap-3">
                        <i class="material-symbols-outlined text-purple-400">syringe</i>
                        <div class="flex flex-column">
                            <span class="font-semibold text-lg mb-2">
                                Treatments ({{ treatments.length }})
                            </span>
                            <div class="flex align-items-center gap-4 text-sm text-600">
                                <span *ngIf="getActiveTreatments().length > 0">
                                    {{ getActiveTreatments().length }} active treatment{{ getActiveTreatments().length
                                    === 1 ? '' : 's' }}
                                </span>
                                <span *ngIf="getActiveTreatments().length === 0 && treatments.length > 0">
                                    No active treatments
                                </span>
                                <span *ngIf="treatments.length === 0">
                                    No treatments recorded
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="flex align-items-center gap-3 text-sm" *ngIf="getLatestTreatment() as latestTreatment">
                        <div class="flex align-items-center justify-content-between gap-2">
                            <span class="font-medium">Latest:</span>
                            <p-tag [style]="{'minWidth':'8em'}" [value]="latestTreatment.treatmentMethodName"
                                [severity]="getTreatmentStatus(latestTreatment)">
                            </p-tag>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-container *ngTemplateOutlet="treatmentsContentTemplate"></ng-container>

        </p-accordionTab>
    </p-accordion>
</ng-container>

<ng-template #nonCollapsibleTemplate>
    <ng-container *ngTemplateOutlet="treatmentsContentTemplate"></ng-container>
</ng-template>

<ng-template #treatmentsContentTemplate>
    <div class="w-full flex flex-column justify-content-center align-items-center gap-3">
        <div *ngIf="treatments.length === 0" class="w-full text-center py-4">
            <p class="text-600">No treatments recorded for this patient.</p>
        </div>

        <p-card *ngFor="let treatment of treatments;" class="w-full">
            <div class="flex justify-content-between align-items-center">
                <div class="col-11 flex flex-row align-items-center justify-content-between gap-4 p-2">
                    <!-- Treatment Method and Status -->
                    <div class="flex flex-column gap-2">
                        <h4 class="m-0 text-primary">{{ treatment.treatmentMethodName }}</h4>
                        <p-tag [style]="{'minWidth':'8em', 'fontSize': '1.1em'}"
                            [value]="getTreatmentStatusLabel(treatment)" [severity]="getTreatmentStatus(treatment)">
                        </p-tag>
                    </div>

                    <!-- Treatment Details - Horizontal Flow -->
                    <div class="flex flex-row align-items-center gap-5 text-sm">
                        <!-- Start Date -->
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-calendar text-primary"></i>
                            <div class="flex flex-column">
                                <span class="font-medium" style="min-width: 5.5rem;">Started</span>
                                <span class="text-600">{{ getHumanReadableDate(treatment.start_date) }}</span>
                            </div>
                        </div>

                        <!-- End Date or Status -->
                        <div class="flex align-items-center gap-2" *ngIf="treatment.end_date; else ongoingStatus">
                            <i class="pi pi-calendar-times text-orange-500"></i>
                            <div class="flex flex-column">
                                <span class="font-medium" style="min-width: 5.5rem;">{{ getTreatmentEndLabel(treatment)
                                    }}</span>
                                <span class="text-600">{{ getHumanReadableDate(treatment.end_date) }}</span>
                            </div>
                        </div>
                        <ng-template #ongoingStatus>
                            <div class="flex align-items-center gap-2">
                                <i class="pi pi-check-circle text-green-500"></i>
                                <div class="flex flex-column">
                                    <span class="font-medium text-green-600" style="min-width: 5.5rem;">Status</span>
                                    <span class="text-green-600">Ongoing</span>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Age at Start -->
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-user text-primary"></i>
                            <div class="flex flex-column">
                                <span class="font-medium" style="min-width: 5.5rem;">Age at start</span>
                                <span class="text-600">{{ treatment.ageAtStartString }}</span>
                            </div>
                        </div>

                        <!-- Duration -->
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-clock text-primary"></i>
                            <div class="flex flex-column">
                                <span class="font-medium" style="min-width: 5.5rem;">Duration</span>
                                <span class="text-600">
                                    <ng-container *ngIf="treatment.end_date; else ongoingDuration">
                                        {{ calculateDuration(treatment.start_date, treatment.end_date) }}
                                    </ng-container>
                                    <ng-template #ongoingDuration>
                                        {{ calculateDurationFromStart(treatment.start_date) }} (ongoing)
                                    </ng-template>
                                </span>
                            </div>
                        </div>

                    </div>

                </div>

                <button class="col-1 p-button-text p-button-plain p-button-rounded" pButton type="button"
                    icon="pi pi-ellipsis-v" (click)="menu.toggle($event)"
                    [attr.aria-label]="'Treatment options for ' + treatment.treatmentMethodName">
                </button>
            </div>

            <div class="flex align-items-center">
                <p-menu #menu appendTo="body" [model]="getTreatmentMenuItems(treatment)" [popup]="true"></p-menu>
            </div>
        </p-card>
    </div>

    <!-- Hamburger Menu -->
</ng-template>

<!-- Update Treatment Dialog -->
<p-dialog appendTo="body" header="Change Treatment" [(visible)]="showUpdateTreatmentDialog" [modal]="true"
    [style]="{width: '35vw'}" [draggable]="false" [resizable]="false" (onHide)="closeUpdateTreatmentDialog()">

    <app-crud-treatment *ngIf="showUpdateTreatmentDialog" [orgId]="orgId" [patientId]="patientId"
        [treatmentId]="selectedTreatmentId" [crudMode]="currentCrudTreatmentMode"
        (onFormSubmit)="onTreatmentFormSubmit()">
    </app-crud-treatment>
</p-dialog>